const state = {
  items: [],
  modelCode: null,
  lastUpdated: null,
};

const mutations = {
  SET_CART_ITEMS(state, items) {
    state.items = items;
    state.lastUpdated = new Date().getTime();
  },
  SET_MODEL_CODE(state, modelCode) {
    state.modelCode = modelCode;
  },
  ADD_ITEM(state, item) {
    const existingIndex = state.items.findIndex(
      (cartItem) => cartItem.partCode === item.partCode
    );

    if (existingIndex > -1) {
      // 이미 있는 아이템이면 수량 증가
      state.items[existingIndex].orderQuantity += 1;
      // 제품코드도 최신으로 업데이트 (전달받은 값 또는 store의 modelCode 사용)
      state.items[existingIndex].searchModelCode =
        item.searchModelCode || null;
    } else {
      // 새로운 아이템 추가
      const cartItem = {
        ...item,
        id: 'temp_' + (Math.floor(Math.random() * 90000) + 10000),
        orderQuantity: item.orderQty || 1,
        no: state.items.length + 1,
        partType: item.partType || '',
        orderUnit: item.orderUnit || '',
        partLevel: item.partLevel || 1,
        searchModelCode: item.searchModelCode || null, // 부품 코드로만 검색 할 경우 존재하여 없으면 null 처리
        requestDate: item.requestDate || '',
      };
      console.log('cartItem', cartItem);
      state.items.push(cartItem);
    }

    // no 재정렬
    state.items.forEach((item, idx) => {
      item.no = idx + 1;
    });

    state.lastUpdated = new Date().getTime();
  },
  REMOVE_ITEM(state, itemId) {
    const index = state.items.findIndex((item) => item.id === itemId);
    if (index > -1) {
      state.items.splice(index, 1);
      // no 재정렬
      state.items.forEach((item, idx) => {
        item.no = idx + 1;
      });
    }
    state.lastUpdated = new Date().getTime();
  },
  UPDATE_ITEM_QUANTITY(state, { itemId, quantity }) {
    const item = state.items.find((item) => item.id === itemId);
    if (item && quantity > 0) {
      item.orderQuantity = quantity;
      state.lastUpdated = new Date().getTime();
    }
  },
  UPDATE_ITEM_IS_FILE(state, { itemId, isFile }) {
    const item = state.items.find(item => item.id === itemId || item.itemId === itemId);
    if (item) {
      item.isFile = isFile;
      state.lastUpdated = new Date().getTime();
    }
  },
  REMOVE_SELECTED_ITEMS(state, selectedIds) {
    state.items = state.items.filter((item) => !selectedIds.includes(item.id));
    // no 재정렬
    state.items.forEach((item, idx) => {
      item.no = idx + 1;
    });
    state.lastUpdated = new Date().getTime();
  },
  CLEAR_CART(state) {
    state.items = [];
    state.lastUpdated = new Date().getTime();
  },
  CLEAR_CART_FOR_MODEL_CHANGE(state) {
    state.items = [];
    state.modelCode = null;
    state.lastUpdated = null;
  },
  UPDATE_ITEM_DELIVERY_DATE(state, { itemId, requestDate }) {
    const item = state.items.find(item => item.id === itemId);
    if (item) {
      item.requestDate = requestDate;
      state.lastUpdated = new Date().getTime();
    }
  }
};

const actions = {
  setModelCode({ commit, state }, modelCode) {
    // 모델코드가 변경되면 기존 장바구니 클리어
    if (state.modelCode && state.modelCode !== modelCode) {
      commit('CLEAR_CART_FOR_MODEL_CHANGE');
    }
    commit('SET_MODEL_CODE', modelCode);
  },
  addItem({ commit }, item) {
    commit('ADD_ITEM', item);
  },
  removeItem({ commit }, itemId) {
    commit('REMOVE_ITEM', itemId);
  },
  updateItemQuantity({ commit }, { itemId, quantity }) {
    commit('UPDATE_ITEM_QUANTITY', { itemId, quantity });
  },
  removeSelectedItems({ commit }, selectedIds) {
    commit('REMOVE_SELECTED_ITEMS', selectedIds);
  },
  clearCart({ commit }) {
    commit('CLEAR_CART');
  },
  setCartItems({ commit }, items) {
    commit('SET_CART_ITEMS', items);
  },
  updateItemRequestDate({ commit }, { itemId, requestDate }) {
    commit('UPDATE_ITEM_DELIVERY_DATE', { itemId, requestDate });
  },
  updateItemIsFile({ commit }, { itemId, isFile }) {
    commit('UPDATE_ITEM_IS_FILE', { itemId, isFile });
  }
};

const getters = {
  cartItems: (state) => state.items,
  cartItemCount: (state) => state.items.length,
  modelCode: (state) => state.modelCode,
  lastUpdated: (state) => state.lastUpdated,
  // 캐시 유효성 검증 (24시간)
  isCacheValid: (state) => {
    if (!state.lastUpdated) return false;
    const now = new Date().getTime();
    const expiryTime = state.lastUpdated + 24 * 60 * 60 * 1000 * 30; // 30일
    return now < expiryTime;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
